module.exports = __webpack_public_path__ + "static/img/cultureItem1.a4cc7ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/cultureItem1.png
// module id = 2ctw
// module chunks = 0